module.exports = __webpack_public_path__ + "img/4.2.6886663b.jpg";